import React from 'react'

/*
  Ideally PageSectionHeader wouldn't have margins b/c they make components more difficult to re-use since they impose
  spacing on the component parent's layout. I didn't want to get rid of the margins yet in the component b/c we use it
  in the Vet Reseller Form and it's non-trivial, though straighforward, to update the layouts in Vet Reseller Form components
  that use the component.
*/

export const PageSectionHeader = ({ children }) => (
  <h4 style={{ color: '#006c9c', textAlign: 'left', marginTop: '1.875rem', marginBottom: '0.5rem', textTransform: 'uppercase' }}>
    {children}
  </h4>
)

